export const PRODUCT_STREAM_ID = 544;
export const STUB_ID = -1;
